import { NgModule } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { AccordionModule } from 'primeng/accordion';
import { TooltipModule } from 'primeng/tooltip';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { PasswordModule } from 'primeng/password';
import { InputMaskModule } from 'primeng/inputmask';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TagModule } from 'primeng/tag';
import { FieldsetModule } from 'primeng/fieldset';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api'
import { BadgeModule } from 'primeng/badge';
import { PanelModule } from 'primeng/panel';
import { DividerModule } from 'primeng/divider';
import { ChartModule } from 'primeng/chart';
import { EditorModule } from 'primeng/editor';
import {KeyFilterModule} from 'primeng/keyfilter';
import { FullCalendarModule } from '@fullcalendar/angular';
import {ScrollPanelModule} from 'primeng/scrollpanel';

@NgModule({
  declarations: [],
  imports: [
    TableModule,
    CalendarModule,
    SliderModule,
    DialogModule,
    MultiSelectModule,
    ContextMenuModule,
    DropdownModule,
    ButtonModule,
    ToastModule,
    InputTextModule,
    ProgressBarModule,
    FileUploadModule,
    ToolbarModule,
    RatingModule,
    RadioButtonModule,
    InputNumberModule,
    BadgeModule,
    ConfirmDialogModule,
    InputSwitchModule,
    InputTextareaModule,
    InputSwitchModule,
    AvatarModule,
    AvatarGroupModule,
    AccordionModule,
    TooltipModule,
    MenuModule,
    CardModule,
    CheckboxModule,
    PasswordModule,
    InputMaskModule,
    OverlayPanelModule,
    TagModule,
    FieldsetModule,
    PanelModule,
    DividerModule,
    ChartModule,
    EditorModule,
    KeyFilterModule,
    ScrollPanelModule
  ],
  exports: [
    TableModule,
    MenuModule,
    BadgeModule,
    CalendarModule,
    SliderModule,
    DialogModule,
    MultiSelectModule,
    ContextMenuModule,
    DropdownModule,
    ButtonModule,
    ToastModule,
    InputTextModule,
    ProgressBarModule,
    FileUploadModule,
    ToolbarModule,
    RatingModule,
    RadioButtonModule,
    InputNumberModule,
    InputSwitchModule,
    ConfirmDialogModule,
    InputTextareaModule,
    InputSwitchModule,
    AvatarModule,
    AvatarGroupModule,
    AccordionModule,
    TooltipModule,
    CardModule,
    CheckboxModule,
    PasswordModule,
    InputMaskModule,
    OverlayPanelModule,
    TagModule,
    FieldsetModule,
    PanelModule,
    DividerModule,
    ChartModule,
    EditorModule,
    KeyFilterModule,
    FullCalendarModule,
    ScrollPanelModule
  ],
  providers: [MessageService, ConfirmationService],
})
export class PrimengModule { }
